import { dataUpdate } from "../service.js";
import React, { Component, Suspense } from "react";
import $ from "jquery";
import calender from "../images/icon-calender.png";
import Pagination from "react-js-pagination";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { cityNameGlobal } from "../components/GlobalCity.js";
const Header = React.lazy(() => import("../layout/header"))
const Footer = React.lazy(() => import("../layout/admin_footer"))
// var cityName = window.location.host.split('.')[0]
// var cityName ="bangalore"
const city = window?.location?.pathname?.split?.('/')?.pop?.();
const cityName = cityNameGlobal ? cityNameGlobal : city
class ContactReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactList: [],
      contactListBackUp: [],
      startDate: "",
      endDate: "",
      searchValue: "",
      DateToprintCsv: "",
      movies: [],
      activePage: 1,
      totalCount: "",
      offset: "",
      allChecked: false,
      deleteId: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }
  handleChange(date) {
    var today = date;
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = mm + dd + yyyy;
    this.setState({
      startDate: date,
      DateToprintCsv: today,
    });
  }
  handleChangeTo(dateTo) {
    this.setState({
      endDate: dateTo,
    });
  }
  componentDidMount() {
    $("#clear").hide();
    if (localStorage.getItem("isLogedIn") === "null" || localStorage.getItem("isLogedIn") === null) {
      window.location.href = '/cms-login'
    }
    var contactData = [];
    var siteId = "";
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    const postData = {
      functionName: "contactReports",
      siteId: siteId,
      offset: "0",
      max: "10",
      "cityName":cityName
    };
    dataUpdate(postData).then((data) => {
      console.log("1234", data.data.result.contactResultReport);
      if (data.data.result.contactResultReport.length > 0) {
        let dataContact = data.data.result.contactResultReport;
        for (var i = 0; i < data.data.result.contactResultReport.length; i++) {
          contactData.push({
            id: i + 1,
            name: dataContact[i].name,
            emailId: dataContact[i].emailId,
            mobileNumber: dataContact[i].mobileNumber,
            courseName: dataContact[i].courseName,
            centerName: dataContact[i].centerName,
            centerId: dataContact[i].centerId,
            // display_name: dataContact[i].display_name,
            reason: dataContact[i].reason,
            cityName: dataContact[i].cityName,
            p_source: dataContact[i].p_source,
            enquiryNumber: dataContact[i].enquiryNumber,
            page_url: dataContact[i].page_url,
            s_source: dataContact[i].s_source,
            stateName: dataContact[i].stateName,
            createdOn: dataContact[i].createdOn,
            // createdTime: dataContact[i].createdTime,
            ip_address: dataContact[i].ip_address,
            isCampaign: dataContact[i].isCampaign,
            contactUsId: dataContact[i].contactUsId,
            browser:dataContact[i].browser,
            device :dataContact[i].devices,
          });
        }
        this.setState({
          contactList: contactData,
          contactListBackUp: contactData,
          totalCount: data.data.result.totalCount,
        });
      }
    });
  }
  searchOnChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      allChecked: false,
    });
  }
  delete() {
    var contactDataDelete = [];
    contactDataDelete = this.state.contactList
      .filter((item) => item.isChecked === true)
      .map((item) => item.contactUsId);
    const postData = {
      functionName: "deleteContactUs",
      selectedContacts: contactDataDelete,
    };
    if (window.confirm("Do you want to delete?")) {
      dataUpdate(postData).then((data) => {
        console.log("delete  ", data);
        if (data.data.success === 1) {
          window.location.reload();
        }
      });
    } else {
      return false;
    }
  }
  selectAllItem = (e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;
    this.setState((prevState) => {
      let { contactList, allChecked } = prevState;
      if (itemName === "selectAll") {
        allChecked = checked;
        contactList = this.state.contactList.map((item) => ({
          ...item,
          isChecked: checked,
        }));
      } else {
        contactList = this.state.contactList.map((item) =>
          parseInt(item.contactUsId) === parseInt(itemName)
            ? { ...item, isChecked: checked }
            : item
        );
        allChecked = this.state.contactList.every((item) => item.isChecked);
      }
      return { contactList, allChecked };
    });
  };

  exportFunction = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = mm + dd + yyyy;
    var FileName;
    if (this.state.DateToprintCsv === "") {
      FileName = "AIC-student-enquiry-from-" + today + ".csv";
    } else {
      FileName =
        "AIC-student-enquiry-from-" + this.state.DateToprintCsv + ".csv";
    }
    var siteId = "";
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    const csvRow = [];
    var patientArray = [
      [
        "SR%20Number",
        "Name",
        "Mobile%20Number",
        "Number%20Verified",
        "Email%20Id",
        // "Qualification",
        "Course%20Name",
        "State",
        "City",
        "Center%20Name",
        "Center%20Id",
        "Enquiry%20Id",
        "Load%20Status",
        "Page%20Name",
        "Psource",
        "Ssource",
        "Date%20of%20Submission",
        "Time%20of%20Submission",
        "IP%20Address",
        // "From%20Campaign",
        "Browser",
        "Devices"
      ],
    ];
    let postData = {
      functionName: "contactReports",
      siteId: siteId,
      searchCategory: $("#dropDownSelection").val(),
      searchText: $("#searchValue").val(),
      fromDate: $("#datewiseDeliverOrderFromDate").val(),
      toDate: $("#datewiseDeliverOrderToDate").val(),
      offset: "0",
      max: "",
      "cityName":cityName
    };
    dataUpdate(postData).then((response) => {
      let dataContact = response.data.result.contactResultReport;
      for (
        var i = 0;
        i < response.data.result.contactResultReport.length;
        i++
      ) {
        patientArray.push([
          i + 1,
          dataContact[i].name,
          dataContact[i].mobileNumber,
          "Not Verified",
          dataContact[i].emailId,
          // dataContact[i].reason,
          dataContact[i].courseName,
          dataContact[i].stateName,
          dataContact[i].cityName,
          dataContact[i].centerName,
          dataContact[i].centerId,
          // dataContact[i].display_name,
          dataContact[i].enquiryNumber,
          dataContact[i].leadStatus === 0 || dataContact[i].leadStatus === undefined ? "" : "Cron Job",
          dataContact[i].page_url,
          dataContact[i].p_source,          
          dataContact[i].s_source,
          dataContact[i].createdOn,
          dataContact[i].submission_date,
          dataContact[i].ip_address,
          // dataContact[i].isCampaign === "1" ? "Yes" : "No",
          dataContact[i].browser,
          dataContact[i].devices,
        ]);
      }
      for (var i = 0; i < patientArray.length; ++i) {
        csvRow.push(patientArray[i].join(","));
      }
      var csvString = csvRow.join("%0A");
      var a = document.createElement("a");
      a.href = "data:attachment/csv," + csvString;
      a.target = "_Blank";
      a.download = FileName;
      document.body.appendChild(a);
      a.click();
    });
  };
  exportFunctionExel = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = mm + dd + yyyy;
    var FileName;
    if (this.state.DateToprintCsv === "") {
      FileName = "AIC-student-enquiry-from-" + today + ".xlsx";
    } else {
      FileName =
        "AIC-student-enquiry-from-" + this.state.DateToprintCsv + ".xlsx";
    }
    var siteId = "";
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    const csvRow = [];
    var patientArray = [
      [
        "SR%20Number",
        "Name",
        "Mobile%20Number",
        "Number%20Verified",
        "Email%20Id",
        // "Qualification",
        "Course%20Name",
        "State",
        "City",
        "Center%20Name",
        "Center%20Id",
        "Enquiry%20Id",
        "Load%20Status",
        "Page%20Name",
        "Psource",
        "Ssource",
        "Date%20of%20Submission",
        "Time%20of%20Submission",
        "IP%20Address",
        // "From%20Campaign",
        "Browser",
        "Devices"
      ],
    ];
    let postData =
    {
      functionName: "contactReports",
      siteId: siteId,
      searchCategory: $("#dropDownSelection").val(),
      searchText: $("#searchValue").val(),
      fromDate: $("#datewiseDeliverOrderFromDate").val(),
      toDate: $("#datewiseDeliverOrderToDate").val(),
      offset: "0",
      max: "",
      "cityName":cityName
    }
    dataUpdate(postData).then((response) => {
      let dataContact = response.data.result.contactResultReport;
      for (
        var i = 0;
        i < response.data.result.contactResultReport.length;
        i++
      ) {
        patientArray.push([
          i + 1,
          dataContact[i].name,
          dataContact[i].mobileNumber,
          "Not Verified",
          dataContact[i].emailId,
          // dataContact[i].reason,
          dataContact[i].courseName,
          dataContact[i].stateName,
          dataContact[i].cityName,
          dataContact[i].centerName,
          dataContact[i].centerId,
          // dataContact[i].display_name,
          dataContact[i].enquiryNumber,
          dataContact[i].leadStatus === 0 || dataContact[i].leadStatus === undefined ? "" : "Cron Job",
          dataContact[i].page_url,
          dataContact[i].p_source,
          dataContact[i].s_source,
          dataContact[i].createdOn,
          dataContact[i].submission_date,
          dataContact[i].ip_address,
          // dataContact[i].isCampaign === "1" ? "Yes" : "No",
          dataContact[i].browser,
          dataContact[i].devices,
        ]);
      }
      for (var i = 0; i < patientArray.length; ++i) {
        csvRow.push(patientArray[i].join(","));
      }
      var csvString = csvRow.join("%0A");
      var a = document.createElement("a");
      a.href = "data:attachment/xlsx," + csvString;
      a.target = "_Blank";
      a.download = FileName;
      document.body.appendChild(a);
      a.click();
    });
  };
  handlePageChange(pageNumber) {
    window.scrollTo(0, 0);
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    var contactData = [];
    var siteId = "";
    this.setState({ activePage: pageNumber, allChecked: false });
    var offset;
    var max;
    if (pageNumber === "1") {
      offset = "0";
      max = "10";
      this.setState({
        activePage: pageNumber,
        isLoading: "0",
      });
    } else {
      offset = parseInt(pageNumber - 1) * 10;
      max = "10";
      this.setState({
        offset: offset,
        activePage: pageNumber,
        isLoading: "0",
      });
    }
    this.setState({
      isData: 0,
    });
    const postData = {
      functionName: "contactReports",
      siteId: siteId,
      searchCategory: $("#dropDownSelection").val(),
      searchText: $("#searchValue").val(),
      fromDate: $("#datewiseDeliverOrderFromDate").val(),
      toDate: $("#datewiseDeliverOrderToDate").val(),
      offset: JSON.stringify(offset),
      max: max,
      "cityName":cityName
    };
    dataUpdate(postData).then((data) => {
      if (data.data.success === "1") {
        if (data.data.result.contactResultReport.length > 0) {
          let dataContact = data.data.result.contactResultReport;
          for (
            var i = 0;
            i < data.data.result.contactResultReport.length;
            i++
          ) {
            contactData.push({
              id: i + 1,
              name: dataContact[i].name,
              emailId: dataContact[i].emailId,
              mobileNumber: dataContact[i].mobileNumber,
              courseName: dataContact[i].courseName,
              centerName: dataContact[i].centerName,
              centerId: dataContact[i].centerId,
              // display_name: dataContact[i].display_name,
              reason: dataContact[i].reason,
              cityName: dataContact[i].cityName,
              p_source: dataContact[i].p_source,
              enquiryNumber: dataContact[i].enquiryNumber,
              leadStatus: dataContact[i].leadStatus,
              page_url: dataContact[i].page_url,
              s_source: dataContact[i].s_source,
              stateName: dataContact[i].stateName,
              createdOn: dataContact[i].createdOn,
              // createdTime: dataContact[i].createdTime,
              ip_address: dataContact[i].ip_address,
              isCampaign: dataContact[i].isCampaign,
              contactUsId: dataContact[i].contactUsId,
              browser:dataContact[i].browser,
              device :dataContact[i].devices,
            });
          }
          this.setState({
            contactList: contactData,
            contactListBackUp: contactData,
            totalCount: data.data.result.totalCount,
            isData: 1,
            allChecked: false,
          });
        }
      }
    });
  }
  searchValueOnChange = (event) => {
    let flag = true;
    if (
      $("#dropDownSelection").val() === "" &&
      $("#searchValue").val() === "" &&
      $("#datewiseDeliverOrderFromDate").val() === "" &&
      $("#datewiseDeliverOrderToDate").val() === ""
    ) {
      $("#clear").hide();
    } else {
      $("#clear").show();
    }
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    var contactData = [];
    var siteId = "";
    var startDate = new Date($("#datewiseDeliverOrderFromDate").val());
    var endDate = new Date($("#datewiseDeliverOrderToDate").val());
    if (startDate > endDate) {
      alert("To date should be greater than or equal to from date");
      return false;
    } else {
      this.setState({
        isData: 0,
        allChecked: false,
      });
      if ((flag = true)) {
        const postData = {
          functionName: "contactReports",
          siteId: siteId,
          searchCategory: $("#dropDownSelection").val(),
          searchText: $("#searchValue").val(),
          fromDate: $("#datewiseDeliverOrderFromDate").val(),
          toDate: $("#datewiseDeliverOrderToDate").val(),
          offset: "0",
          max: "10",
          "cityName":cityName
        };
        dataUpdate(postData).then((data) => {
          if (data.data.success === "1") {
            if (data.data.result.totalCount > 0) {
              let dataContact = data.data.result.contactResultReport;
              for (
                var i = 0;
                i < data.data.result.contactResultReport.length;
                i++
              ) {
                contactData.push({
                  id: i + 1,
                  name: dataContact[i].name,
                  emailId: dataContact[i].emailId,
                  mobileNumber: dataContact[i].mobileNumber,
                  courseName: dataContact[i].courseName,
                  centerName: dataContact[i].centerName,
                  centerId: dataContact[i].centerId,
                  // display_name: dataContact[i].display_name,
                  reason: dataContact[i].reason,
                  cityName: dataContact[i].cityName,
                  p_source: dataContact[i].p_source,
                  enquiryNumber: dataContact[i].enquiryNumber,
                  leadStatus: dataContact[i].leadStatus,
                  page_url: dataContact[i].page_url,
                  s_source: dataContact[i].s_source,
                  stateName: dataContact[i].stateName,
                  createdOn: dataContact[i].createdOn,
                  // createdTime: dataContact[i].createdTime,
                  ip_address: dataContact[i].ip_address,
                  isCampaign: dataContact[i].isCampaign,
                  contactUsId: dataContact[i].contactUsId,
                  browser:dataContact[i].browser,
                  device :dataContact[i].devices,
                });
              }
              this.setState({
                contactList: contactData,
                contactListBackUp: contactData,
                totalCount: data.data.result.totalCount,
                isData: 1,
                offset: 0,
                allChecked: false,
              });
              $("#clear").style.display = "block";
            } else {
              this.setState({
                contactList: [],
                contactListBackUp: [],
                totalCount: data.data.result.totalCount,
                isData: 1,
                allChecked: false,
              });
            }
          }
        });
      }
    }
  };
  cancel = (event) => {
    $("#clear").hide();
    if (localStorage.getItem("role") === "Admin") {
      siteId = localStorage.getItem("username");
    }
    var contactData = [];
    var siteId = "";
    const postData = {
      functionName: "contactReports",
      siteId: siteId,
      fromDate: "",
      toDate: "",
      offset: "0",
      max: "10",
      "cityName":cityName
    };
    dataUpdate(postData).then((data) => {
      if (data.data.success === "1") {
        $("#dropDownSelection").val("");
        $("#searchValue").val("");
        $("#datewiseDeliverOrderFromDate").val("");
        $("#datewiseDeliverOrderToDate").val("");
        this.setState({
          activePage: 1,
          startDate: "",
          endDate: "",
          allChecked: false,
          offset: 0,
        });
        if (data.data.result.contactResultReport.length > 0) {
          let dataContact = data.data.result.contactResultReport;
          for (
            var i = 0;
            i < data.data.result.contactResultReport.length;
            i++
          ) {
            contactData.push({
              id: i + 1,
              name: dataContact[i].name,
              emailId: dataContact[i].emailId,
              mobileNumber: dataContact[i].mobileNumber,
              courseName: dataContact[i].courseName,
              centerName: dataContact[i].centerName,
              centerId: dataContact[i].centerId,
              // display_name: dataContact[i].display_name,
              reason: dataContact[i].reason,
              cityName: dataContact[i].cityName,
              p_source: dataContact[i].p_source,
              enquiryNumber: dataContact[i].enquiryNumber,
              page_url: dataContact[i].page_url,
              s_source: dataContact[i].s_source,
              stateName: dataContact[i].stateName,
              createdOn: dataContact[i].createdOn,
              // createdTime: dataContact[i].createdTime,
              ip_address: dataContact[i].ip_address,
              isCampaign: dataContact[i].isCampaign,
              contactUsId: dataContact[i].contactUsId,
              browser:dataContact[i].browser,
              device :dataContact[i].devices,
            });
          }
          this.setState({
            contactList: contactData,
            contactListBackUp: contactData,
            totalCount: data.data.result.totalCount,
            isData: 1,
            allChecked: false,
          });
        }
      }
    });
  };
  render() {
    return (
      <section className="contact_report clearfix">
        <div className="">
          <Suspense fallback={<div></div>}>
            <Header />
            <div className="container dashbrd_listheight">
              <div className="breadcrumbs breadcrumbs_dashboard d-flex align-items-center">
                <ul>
                  {localStorage.getItem("isLogedIn") === "1" ? (
                    <li>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                  ) : (
                    <li>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                  )}
                  <div class="breadcrumbarrow-right" />
                  <li>View Reports - Student Enquiry</li>
                </ul>
              </div>
              <h2 className="text-center w-100 contact-report-head">Contact Report</h2>
              <div className="row am_block text-center pb-2">
                <div className="col-lg-2 col-md-3 input-div">
                  <select
                    tabIndex={4}
                    placeholder="Qualification"
                    id="dropDownSelection"
                    className="form-control selectFormControl"
                  >
                    <option value="">Filter By</option>
                    <option value="name">Name</option>
                    <option value="emailId">Email</option>
                    <option value="mobileNumber">Mobile Number</option>
                    <option value="is_campaign">isCampaign</option>
                  </select>
                </div>
                <div className="col-lg-2 col-md-3 input-div">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="searchValue"
                    id="searchValue"
                    onChange={this.searchOnChange}
                  />
                </div>
                <div className="col-lg-2 col-md-3 input-div">
                  <img src={calender} className="formImage" alt="calender" />
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleChange}
                    className="form-control"
                    dateFormat="yyyy/MM/dd"
                    id="datewiseDeliverOrderFromDate"
                    name="datewiseDeliverOrderFromDate"
                    placeholderText="Start Date"
                  />
                </div>
                <div className="col-lg-2 col-md-3 input-div">
                  <img src={calender} className="formImage" alt="calender" />
                  <DatePicker
                    selected={this.state.endDate}
                    onChange={this.handleChangeTo}
                    dateFormat="yyyy/MM/dd"
                    className="form-control"
                    id="datewiseDeliverOrderToDate"
                    name="datewiseDeliverOrderToDate"
                    placeholderText="End Date"
                  />
                </div>
                <div className="col-lg-4 col-md-12 input-div">
                  <span
                    className="saveButton"
                    onClick={() => this.searchValueOnChange()}
                  >
                    Search
                  </span>
                  <span
                    className="cancelButton"
                    id="clear"
                    style={{ display: "none" }}
                    onClick={() => this.cancel()}
                  >
                    Clear
                  </span>
                  <button
                    type="button"
                    className="saveButton"
                    onClick={() => this.exportFunctionExel()}
                  >
                    Export Excel
                  </button>
                  <button
                    type="button"
                    className="saveButton"
                    onClick={() => this.exportFunction()}
                  >
                    Export CSV
                  </button>
                </div>
              </div>
              <div className="row">
                {this.state.totalCount > 10 ? (
                  <div className="pagination_div topPagination">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={this.state.totalCount}
                      pageRangeDisplayed={10}
                      onChange={this.handlePageChange}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="table-responsive ">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ width: "120px", display: "block" }}>
                        <span
                          class="select_deletebtn"
                          onClick={(e) => this.delete(e)}
                        >
                          Delete
                        </span>
                        <div>
                          <span className="pr-1">Select All</span>
                          <input
                            type="checkbox"
                            name="selectAll"
                            id="selectAll"
                            checked={this.state.allChecked}
                            onChange={(e) => this.selectAllItem(e)}
                          />
                        </div>
                      </th>
                      <th>SR Number</th>
                      <th>Name</th>
                      <th>Mobile no.</th>
                      <th>Number Verified</th>
                      <th>Email ID</th>
                      {/* <th>Qualification</th> */}
                      <th>Course Name</th>
                      <th>State</th>
                      <th>City</th>
                      <th>Center Name</th> 
                      <th>Center Id</th>
                      <th>Enquiry Id</th>
                      <th>Lead Status</th>
                      <th>Page Name</th>
                      <th>Psource</th>
                      <th>Ssource</th>
                      <th>Date of Submission</th>
                     <th>Time of Submission</th> 
                      <th>IP Address</th>
                      {/* <th>From Campaign</th> */}
                      <th>Browsers</th>
                      <th>Devices</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.totalCount > 0 ? (
                      this.state.contactList.map((obj, i) => (
                        <tr>
                          {console.log("obj.leadStatus", obj.leadStatus)}
                          <td className="text-center">
                            <input
                              key={obj.id}
                              type="checkbox"
                              name={obj.contactUsId}
                              value={obj.contactUsId}
                              checked={obj.isChecked}
                              onChange={this.selectAllItem}
                            />
                          </td>
                          <td>{this.state.offset + obj.id}</td>
                          <td>{obj.name}</td>
                          <td>{obj.mobileNumber}</td>
                          <td>Not Verified</td>
                          <td>{obj.emailId}</td>
                          {/* <td>{obj.reason}</td> */}
                          <td>{obj.courseName}</td>
                          <td>{obj.stateName}</td>
                          <td>{obj.cityName}</td>
                          <td>{obj.centerName}</td> 
                          <td>{obj.centerId}</td>
                          {/* <td>{obj.display_name}</td> */}
                          <td>{obj.enquiryNumber}</td>
                          <td>{obj.leadStatus === 0 || obj.leadStatus === undefined ? "" : "Cron Job"}</td>
                          <td>{obj.page_url}</td>
                          <td>{obj.p_source}</td>
                          <td>{obj.s_source}</td>
                          <td>{obj.createdOn}</td>
                          <td>{obj.submission_date !== null ? moment(obj.submission_date).format('hh:mm A') : ""}</td> 
                          <td>{obj.ip_address}</td>
                          {/* {obj.isCampaign == 0 ? <td>No</td> : <td>Yes</td>} */}
                          <td>{obj.browser}</td>
                          <td>{obj.device}</td>
                        </tr>
                      ))
                    ) : this.state.totalCount === 0 ? (
                      <div>No Data Found</div>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                {this.state.totalCount > 10 ? (
                  <div className="pagination_div">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={this.state.totalCount}
                      pageRangeDisplayed={10}
                      onChange={this.handlePageChange}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <Footer />
          </Suspense>
        </div>
      </section>
    );
  }
}
export default ContactReport;
